import Vue from 'vue'
import App from './App.vue'
import Maintenace from "./views/Maintainance.vue";
import router from './router'
import store from './store'

import './registerServiceWorker'
import { i18n } from '@/plugins/languages'
import ApnHeader from '@/components/ApnHeader'
import ApnToast from './components/ApnToast'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.component('ApnHeader', ApnHeader)
Vue.component('ApnToast', ApnToast)
Vue.component('v-select', vSelect)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
